import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../services/localstorage.service';
import { ToolsService } from '../services/tools.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { precos } from '../model/precos.model';
import { MensagemRetornoComponent } from '../components/mensagem-retorno/mensagem-retorno.component';
import { ContentObserver } from '@angular/cdk/observers';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Component({
  selector: 'app-preco-combustivel',
  templateUrl: './preco-combustivel.component.html',
  styleUrls: ['./preco-combustivel.component.scss']
})

export class PrecoCombustivelComponent implements OnInit {
  constructor(private toolsService: ToolsService<any>,
    private localStorageService: LocalStorageService,
    private modalService: NgbModal
  ) { }

  loading: boolean = false;
  guid: any;
  usuario: any;

  notificacaoModal = false;
  notificacaoTela = false;
  notificacaoMensagens: any = [];
  notificacaoStatus = 'alert-success';

  combustivelSelecionado: string = 'S';
  teste = false;
  combustiveis: any = [];
  closeResult = '';
  combustivelSelecionadoItem: any = null;

  tipoDesconto: any = 'descporcentagem';
  precoClicado: any;
  itemSelecionadoPrecoUnitario: any;
  itemSelecionadoPrecoNegociado: any;
  itemSelecionado: any;
  novoPreco: any;
  precoAnterior: any;
  preco: precos[] = [];
  precos: any = [];

  getGasPrices: any = [];
  //getGasPricesSource:any;
  combustivel: any;
  lastSegment: any;
  calculosPorcentagem: any = {};

  async ngOnInit() {
    this.getPrices();
  }

  async getPrices() {
    this.loading = true;

    this.tipoDesconto = this.localStorageService.getItem('tipoDesconto');
    if (this.tipoDesconto == null)
      this.tipoDesconto = "descporcentagem";

    var userData = this.localStorageService.getItem('userData');
    this.guid = this.localStorageService.getItem('guid');

    var dadosCombustiveis: any = null;
    if (userData != null && this.guid != null) {
      this.usuario = JSON.parse(userData);
      //console.log(this.usuario);
      var dadosConsulta = {
        "codPosto": this.usuario.retorno.codigoEntidade.toString(),
        "guid": this.guid
      }
      //console.log(dadosConsulta);
      var dadosCombustivel = await this.toolsService.post(environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaDePreco, JSON.stringify(JSON.stringify(dadosConsulta)));
      if (dadosCombustivel.sucesso) {
        dadosCombustiveis = JSON.parse(dadosCombustivel.retorno.response);
        //console.log(dadosCombustiveis);

        this.combustiveis = this.convertResponseConsultaPrecos(dadosCombustiveis);

        this.getGasPrices = this.combustiveis;
        this.combustivel = "S";
        this.lastSegment = "S";
        //this.convertPrice();
        //this.getGasPricesSource = JSON.stringify(this.getGasPrices);
        this.calculosPorcentagem = this.calPorcentagem();

      }

      //console.log(this.combustiveis);
      //console.log(this.combustivelSelecionado);
    }
    this.loading = false;
  }

  async cadastrarPreco(
    guid: any,
    codPosto: any,
    dsclogin: any,
    dscemail: any,
    dsctelefone: any,
    combustivel: any
  ): Promise<any> {

    let data = {
      guid: guid,
      codPosto: codPosto,
      dsclogin: dsclogin,
      dscemail: dscemail,
      dsctelefone: dsctelefone,
      combustivel: combustivel,
    };
    //console.log(data);

    return this.toolsService.post(environment.host_ctf_service+ CONFIG_URLS_API.API_CadastroDePreco, JSON.stringify(JSON.stringify(data)));
  }

  carregarDadosAjustePreco(itemSelecionado: any) {
    //console.log("itemSelecionado");
    //console.log(itemSelecionado);

    this.itemSelecionado = itemSelecionado;

    this.itemSelecionadoPrecoUnitario = itemSelecionado.combustivel.precos.filter((preco: any) => {
      return preco.id == "precoUnitario";
    });
    this.itemSelecionadoPrecoUnitario = this.itemSelecionadoPrecoUnitario[0];

    this.itemSelecionadoPrecoNegociado = itemSelecionado.combustivel.precos.filter((preco: any) => {
      return preco.id == "precoNegociado";
    });
    this.itemSelecionadoPrecoNegociado = this.itemSelecionadoPrecoNegociado[0];
    this.novoPreco = {};

    this.novoPreco.precoAtual = this.itemSelecionadoPrecoUnitario.preco
    //this.novoPreco.precoAtual = this.toolsService.convertToNumber(this.itemSelecionadoPrecoUnitario.preco);

    this.novoPreco.precoNegociado = this.precoClicado.preco
    //this.novoPreco.precoNegociado = this.toolsService.convertToNumber(this.precoClicado.preco);

    this.novoPreco.descontoReal = this.novoPreco.precoAtual - this.novoPreco.precoNegociado;
    //this.novoPreco.descontoReal = this.novoPreco.precoAtual - this.toolsService.convertToNumber(this.novoPreco.precoNegociado);

    this.novoPreco.descontoReal = this.toolsService.formatDecimal2(
      this.novoPreco.descontoReal);
    this.novoPreco.descontoPorcentagem =
      (this.novoPreco.descontoReal / this.novoPreco.precoAtual) * 100;
    // console.log(this.novoPreco);
    let D = this.novoPreco.descontoReal;
    this.novoPreco.descontoReal = this.toolsService.formatDecimal2(
      String(D)//.replace(".", ",")
    );
    this.novoPreco.precoAtual = this.toolsService.formatDecimal2(
      String(this.novoPreco.precoAtual)//.replace(".", ",")
    );
    this.novoPreco.precoNegociado = this.toolsService.formatDecimal2(
      String(this.novoPreco.precoNegociado)//.replace(".", ",")
    );
    D = this.novoPreco.descontoPorcentagem;
    this.novoPreco.descontoPorcentagem = this.toolsService.formatDecimal(
      String(D)//.replace(".", ",")
    );
    this.novoPreco.precoAnterior = this.itemSelecionadoPrecoUnitario.precoAnterior;
    if (!this.novoPreco.precoAnterior) {
      this.novoPreco.precoAnterior = this.novoPreco.precoAtual;
    }
    this.novoPreco.idItem = this.precoClicado.id;
    this.novoPreco.descricaoItem = this.precoClicado.descricao;
    this.novoPreco.tituloItem = this.precoClicado.titulo;

    //console.log('Precos:');
    //console.log(this.itemSelecionadoPrecoUnitario);
    //console.log(this.itemSelecionadoPrecoNegociado);
    //console.log(this.novoPreco);
  }

  open(content: any) {
    this.modalService.open(content, { windowClass: 'custom-window-class', ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  openAjustePreco(content: any, precoClicado: any, item: any) {
    this.notificacaoModal = false;
    //console.log(this.tipoDesconto);
    this.combustivelSelecionadoItem = item;
    this.precoClicado = precoClicado;
    //console.log("precoClicado");
    //console.log(this.precoClicado);

    this.carregarDadosAjustePreco(this.combustivelSelecionadoItem);

    //console.log(this.combustivelSelecionadoItem);

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openGas(combustivel: string) {
    this.combustivelSelecionado = combustivel;
    //console.log(this.combustivelSelecionado);
  }

  convertResponseConsultaPrecos(combustiveis: any) {
    for (let item in combustiveis) {
      let precos = [];
      let precosItem = combustiveis[item].combustivel.precos;
      for (let preco in precosItem) {
        combustiveis[item].combustivel.precos[preco][0].preco =
          String(
            combustiveis[item].combustivel.precos[preco][0].preco
          );//.replace(".", ",");

        precos.push(
          combustiveis[item].combustivel.precos[preco][0]
        );
      }
      combustiveis[item].combustivel.precos = precos;
    }

    //console.log("NOVO", combustiveis);
    return combustiveis;
  }


  calPorcentagem() {

    let precos: any = this.combustiveis;
    let retorno: any = {};
    //console.log('calPorcentagem');
    //console.log(precos);
    try {
      precos.forEach((item: any) => {
        // if (item.indCombustivel == this.combustivel) {
        let precoUnitario = item.combustivel.precos.find((preco: any) => {
          return preco.id == "precoUnitario";
        });
        let precosDinamicos = item.combustivel.precos.filter((preco: any) => {
          return preco.id != "precoUnitario";
        });
        retorno[item.indCombustivel] = {};
        for (let i in precosDinamicos) {
          let preco = precosDinamicos[i];
          let id = preco.id;
          let valorUnitario = Number(precoUnitario.preco);
          let valorDinamico = Number(preco.preco);
          let porcentagem: any = (valorDinamico / valorUnitario) * 100;
          porcentagem = porcentagem.toFixed(3);
          retorno[item.indCombustivel][preco.id] = {
            porcentagem: porcentagem,
          };
        }
        //   }
      });
    } catch (error) {
      console.error(error);
    }

    //console.log('PORCENTAGEM', retorno);

    return retorno;
  }

  calcPercentage(event: any) {
    if (this.tipoDesconto == "descporcentagem") {
      this.localStorageService.setItem("tipoDesconto", this.tipoDesconto);
      setTimeout(async () => {
        let valor = Number(this.novoPreco.descontoPorcentagem);//);
        let valorfrom = Number(this.novoPreco.precoAtual)//.replace(",", "."));
        let desconto = (valorfrom * valor) / 100;

        //console.log(this.novoPreco.descontoPorcentagem);

        this.novoPreco.precoNegociado = String(valorfrom - desconto);//.replace(".", ",")
        this.novoPreco.descontoReal = String(desconto);

      }, 100);
    } else if (this.tipoDesconto == "descreais") {
      this.localStorageService.setItem("tipoDesconto", this.tipoDesconto);
      setTimeout(async () => {
        let descontoemCetavos = Number(this.novoPreco.descontoReal);//);
        let precounitario = Number(this.novoPreco.precoAtual);//.replace(",", "."));

        //console.log(event.target.value);
        //console.log(this.novoPreco.descontoReal);
        //console.log(this.novoPreco.precoAtual);

        if (descontoemCetavos > precounitario) {
          descontoemCetavos = precounitario;
          this.novoPreco.precoNegociado = String(descontoemCetavos);
        }
        let descontoPorcentagem = (descontoemCetavos / precounitario) * 100;
        this.novoPreco.precoNegociado = String(precounitario - descontoemCetavos);

        this.novoPreco.descontoPorcentagem = descontoPorcentagem;
      }, 100);
    }
  }

  calcCampoPercentage(event: any) {
    if (this.tipoDesconto == "descporcentagem") {
      this.localStorageService.setItem("tipoDesconto", this.tipoDesconto);
      setTimeout(async () => {
        let desconto = ((this.novoPreco.precoNegociado / this.novoPreco.precoAtual) - 1) * -1;

        //console.log(this.novoPreco.descontoPorcentagem);

        this.novoPreco.descontoPorcentagem = desconto * 100;
        //this.novoPreco.precoNegociado = String(valorfrom - desconto);//.replace(".", ",")
        this.novoPreco.descontoReal = this.novoPreco.precoAtual - this.novoPreco.precoNegociado;

      }, 100);
    } else if (this.tipoDesconto == "descreais") {
      this.localStorageService.setItem("tipoDesconto", this.tipoDesconto);
      setTimeout(async () => {
        let desconto = ((this.novoPreco.precoNegociado / this.novoPreco.precoAtual) - 1) * -1;

        let descontoemCetavos = Number(this.novoPreco.descontoReal);//);
        let precounitario = Number(this.novoPreco.precoAtual);//.replace(",", "."));

        //console.log(event.target.value);
        //console.log(this.novoPreco.descontoReal);
        //console.log(this.novoPreco.precoAtual);

        //this.novoPreco.precoNegociado = String(precounitario - descontoemCetavos);
        this.novoPreco.descontoReal = String(this.novoPreco.precoAtual - this.novoPreco.precoNegociado);
        this.novoPreco.descontoPorcentagem = desconto * 100;
      }, 100);
    }
  }

  inputChange(event: any, preco: any, precoMax: any, precoMaxString: any) {

    //console.log(event, preco, precoMax, precoMaxString)

    setTimeout(async () => {
      let valor = Number(event.target.value);//.replace(",", "."));
      if (valor > precoMax ) {
        preco.valor = precoMaxString;
      }
    }, 100);
  }

  getPrecoAnterior(combustivel?: any) {
    if (!combustivel) {
      combustivel = this.combustivel;
    }
    let getGasPrices = this.combustiveis;
    let precoUnitario = getGasPrices.find((item: any) => {
      return item.indCombustivel == combustivel;
    });
    precoUnitario = precoUnitario.combustivel.precos.find((item: any) => {
      return item.id == "precoUnitario";
    });
    precoUnitario.preco = Number(String(precoUnitario.preco));
    return precoUnitario;
  }

  async addPrice(segment?: any) {
    this.loading = true;

    for (let i in this.novoPreco) {
      if (this.novoPreco[i] && String(this.novoPreco[i]).indexOf(",") !== -1) {
        this.novoPreco[i] = Number(String(this.novoPreco[i]).replace(",", "."));
      }
    }

    let payloadCombustivel: any = {
      indCombustivel: this.combustivelSelecionado,
      precoPrazo: {
        valor: 0,
      },
      precoUnitario: {
        valor: this.novoPreco.precoAnterior,
        descricao: "Preço unitário",
      },
      descontoPercentual: {
        valor: this.novoPreco.descontoPorcentagem,
        descricao: "Desconto em porcentagem",
      },
      descontoCentavos: {
        valor: this.novoPreco.descontoReal,
        descricao: "Desconto em real",
      },
      precoAnterior: {
        valor: this.novoPreco.precoAnterior,
        descricao: "Preço anterior",
      },
      precoNovo: {
        valor: this.novoPreco.precoAtual,
        descricao: "Preço novo",
      },
    };

    payloadCombustivel[this.novoPreco.idItem] = {
      valor: this.novoPreco.precoNegociado,
      descricao: this.novoPreco.descricaoItem,
    };

    for (let preco in this.itemSelecionado?.combustivel?.precos) {
      if (!payloadCombustivel[this.itemSelecionado.combustivel.precos[preco].id]) {
        payloadCombustivel[this.itemSelecionado.combustivel.precos[preco].id] = {
          valor: Number(
            String(this.itemSelecionado.combustivel.precos[preco].preco).replace(",", ".")
          ),
        };
      }
    }

    if (segment) {
      payloadCombustivel.indCombustivel = segment;
      payloadCombustivel.descricaoCombustivel = segment;
    } else {
      payloadCombustivel.indCombustivel = this.itemSelecionado.indCombustivel;
      payloadCombustivel.descricaoCombustivel = this.itemSelecionado.descricaoCombustivel;
    }

    payloadCombustivel.precoPrazo.descricao == "Preço Prazo";

    var dataRetorno = await this.cadastrarPreco(
      this.guid,
      Number(this.usuario.retorno.codigoEntidade.toString()),
      this.usuario.retorno.login,
      this.usuario.retorno.email,
      this.usuario.retorno.celular,
      payloadCombustivel
    );
    //console.log(dataRetorno);
    this.preco.push(this.precos);
    ({
      precoPrazo: dataRetorno.precoPrazo,
      precoUnitario: dataRetorno.precoUnitario,
      descontoPercentual: dataRetorno.descontoPercentual,
      descontoCentavos: dataRetorno.descontoCentavos,
      precoAnterior: dataRetorno.precoAnterior,
      precoNovo: dataRetorno.precoNovo,
      precoNegociado: dataRetorno.precoNegociado,
    });

    if (dataRetorno.sucesso == true) {
      //this.loading.dismiss();

      let mensagemCombustivel = payloadCombustivel.descricaoCombustivel;

      this.notificacaoStatus = 'alert-success';
      this.notificacaoModal = true;

      this.notificacaoStatus = 'alert-success';
      this.notificacaoTela = true;

      this.notificacaoMensagens = JSON.parse(dataRetorno.retorno.response);
      //console.log(this.notificacaoMensagens);

      this.modalService.dismissAll('funcão addPrice');

      //console.log('sucesso');
    }
    else {

      this.notificacaoStatus = 'alert-danger';
      this.notificacaoModal = true;
      this.notificacaoTela = true;

      this.notificacaoMensagens = [{ DSC_RETORNO: dataRetorno.mensagens }];
      //console.log(this.notificacaoMensagens);

      //console.log('erro verificar');
    }

    this.getPrices();

    if (this.precoClicado.id == 'precoUnitario') {
      //console.log('this.precoClicado.id', this.precoClicado.id)
      this.saveAll(this.combustivelSelecionado, true);
    }

    this.loading = false;
  }


  async saveAll(combustivel?: any, atualizaTudo?: any) {

    this.loading = true;

    let itemCombustivel;
    if (!combustivel) {
      combustivel = this.combustivelSelecionado;
    }

    for (let index in this.getGasPrices) {
      let item = this.getGasPrices[index];
      if (item.indCombustivel == combustivel) {
        itemCombustivel = item;
        let itemPrecoUnitario = item.combustivel.precos.filter((preco: any) => {
          return preco.id == "precoUnitario";
        })[0];
        let payLoad: any = {};

        if (atualizaTudo) {
          for (let j in item.combustivel.precos) {
            let preco = item.combustivel.precos[j];
            let valorAtualizacao = 0;

            if (preco.id == 'precoUnitario') {
              payLoad[preco.id] = {
                valor: this.novoPreco.precoAtual,
                descricao: preco.descricao,
              };
            }
            else {
              let porcCalculada = this.calculosPorcentagem[this.combustivelSelecionado][preco.id]["porcentagem"] != 'NaN';

              if (porcCalculada)
                valorAtualizacao = this.novoPreco.precoAtual * Number(this.calculosPorcentagem[this.combustivelSelecionado][preco.id]["porcentagem"]) / 100;
              //console.log('valorAtualizacao: ', valorAtualizacao.toPrecision(2));
              payLoad[preco.id] = {
                valor: valorAtualizacao,
                descricao: preco.descricao,
               // descontoPercentual: 1 - (Number(this.calculosPorcentagem[this.combustivelSelecionado][preco.id]["porcentagem"]) / 100),
               // descontoCentavos: this.novoPreco.precoAtual - valorAtualizacao,
              };

              payLoad.descontoPercentual = {
                valor: (100 - (Number(this.calculosPorcentagem[this.combustivelSelecionado][preco.id]["porcentagem"]))),
                descricao: "Desconto em porcentagem",
              }
              payLoad.descontoCentavos = {
                valor: this.novoPreco.precoAtual - valorAtualizacao,
                descricao: "Desconto em real",
              };
            }
          }
        }
        else {
          for (let j in item.combustivel.precos) {
            let preco = item.combustivel.precos[j];
            payLoad[preco.id] = {
              valor: Number(String(preco.preco)),
              descricao: preco.descricao,
            };
          }
        }
        payLoad.descricaoCombustivel = item.descricaoCombustivel;
        payLoad.indCombustivel = item.indCombustivel;
        payLoad.precoAnterior = {
          valor: Number(
            String(this.getPrecoAnterior(combustivel).preco)
          ),
        };
        /*payLoad.descontoPercentual = {
          valor: 0,
          descricao: "Desconto em porcentagem",
        };
        payLoad.descontoCentavos = {
          valor: 0,
          descricao: "Desconto em real",
        };
        */
        payLoad.precoNovo = payLoad.precoUnitario;
        if (isNaN(payLoad.precoAnterior.valor)) {
          payLoad.precoAnterior.valor = payLoad.precoNovo.valor;
        }
        //console.log(payLoad);
        var dataRetorno = await this.cadastrarPreco(
          this.guid,
          Number(item.combustivel.codPosto),
          this.usuario.retorno.login,
          this.usuario.retorno.email,
          this.usuario.retorno.celular,
          payLoad
        );

        //console.log(dataRetorno);

        if (dataRetorno.sucesso == true) {
          //this.loading.dismiss();

          let mensagemCombustivel = payLoad.descricaoCombustivel;

          this.notificacaoStatus = 'alert-success';
          this.notificacaoTela = true;

          this.notificacaoMensagens = JSON.parse(dataRetorno.retorno.response);
          //console.log(this.notificacaoMensagens);

          //console.log('sucesso');
        }
        else {
          this.notificacaoStatus = 'alert-danger';
          this.notificacaoTela = true;

          this.notificacaoMensagens = JSON.parse(dataRetorno.retorno.response);
          //console.log(this.notificacaoMensagens);

          //console.log('erro verificar');
        }
      }
    }

    this.getPrices();
    this.loading = false;
  }

  fecharNotificacaoModal() {
    this.notificacaoModal = false;
  }

  fecharNotificacao() {
    this.notificacaoTela = false;
  }

}
